import { useEffect, useState, useCallback } from "react";

/** localStorage key for the user-preferred scope filter on Leads/Negócios pages. */
const STORAGE_KEY = "ihtp.scopeFilter";

/**
 * useScopeFilter — persistente toggle entre "own" e "all".
 *
 * Devolve `[scope, setScope]` análogo ao `useState` mas guarda em localStorage
 * a escolha do utilizador. Defaults to "all" (toda a rede) — alinhado com a
 * regra de visibilidade actual.
 *
 * Aplica-se a leads/list, leads/kanban e negocios/list para que o consultor
 * mantenha a sua escolha entre páginas.
 */
export default function useScopeFilter(defaultValue = "all") {
  const [scope, setScopeState] = useState(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      return stored === "own" || stored === "all" ? stored : defaultValue;
    } catch {
      return defaultValue;
    }
  });

  useEffect(() => {
    try { localStorage.setItem(STORAGE_KEY, scope); } catch (_e) { /* private mode */ }
  }, [scope]);

  const setScope = useCallback((next) => {
    setScopeState(next === "own" ? "own" : "all");
  }, []);

  return [scope, setScope];
}
